import check_url_is_ajax from "./check_url_is_ajax"
import start_request from "./start_request"

export default (url: string) => {
  if (check_url_is_ajax(url)) {
    start_request(url, {})
  } else {
    window.location.href = url
  }
}
